import { z } from 'zod'

export const agreementSearchSchema = z.object({
  status: z.enum(['all', 'toSignEdu', 'toSignOther', 'missingData', 'signed']).catch('all'),
  search: z.string().max(200).optional().catch(undefined),
  groupId: z.string().optional().catch(undefined),
  internshipId: z.string().optional().catch(undefined),
  templateId: z.string().optional().catch(undefined),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z
    .enum(['nr', 'intern', 'org', 'eduSigned', 'orgSigned', 'internSigned', 'status'])
    .catch('nr'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})

export type AgreementSearch = z.infer<typeof agreementSearchSchema>

export const defaultAgreementSearch: AgreementSearch = {
  status: 'all',
  page: 1,
  pageSize: 10,
  sortBy: 'nr',
  direction: 'asc',
}
